import React, { useState, useEffect, useCallback } from "react";
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { useNotification } from "../../providers/NotificationProvider";
import { fetchProductTypes } from "../../api/memberApi";

export default function ProductTypeListPage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchProductTypes(businessDomainId);
      setItems(Array.isArray(data) ? data : []);
    } catch (e) { notify.apiError(e); }
    finally { setLoading(false); }
  }, [businessDomainId]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { loadData(); }, [loadData]);

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3, gap: 2 }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(`/design/${businessDomainId}`)} variant="text">
          {t("common.back")}
        </Button>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>{t("productType.list.title")}</Typography>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}><CircularProgress /></Box>
      ) : items.length === 0 ? (
        <Typography color="text.secondary">{t("common.noData")}</Typography>
      ) : (
        <TableContainer component={Paper} variant="outlined">
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "grey.50" }}>
                <TableCell sx={{ fontWeight: 600 }}>{t("common.name")}</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>{t("productType.valueProposition")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item) => (
                <TableRow key={item.productTypeId} hover sx={{ cursor: "pointer" }}
                  onClick={() => navigate(`/design/${businessDomainId}/product-types/${item.productTypeId}`)}>
                  <TableCell>{item.productTypeName || "—"}</TableCell>
                  <TableCell>{item.valueProposition || "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
